import React from 'react';
import CartItems from '../componnents/CartItems/CartItems';

const Cart = () => {
  return (
    <div className="page-shell page-shell--muted">
      <CartItems />
    </div>
  );
};

export default Cart;
